import { render } from "./reviewMember.vue?vue&type=template&id=6104ec4e&ts=true"
import script from "./reviewMember.vue?vue&type=script&lang=ts"
export * from "./reviewMember.vue?vue&type=script&lang=ts"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__